import { mpstopicfile } from "../guidelines.js";

export function createUrlFromDitaFilename(filename) {
  if (!filename || typeof filename !== "string") {
    console.error("Invalid filename provided:", filename);
    return "#";
  }

  let cleanedFilename = filename;
  while (cleanedFilename.startsWith("../")) {
    cleanedFilename = cleanedFilename.substring(3);
  }
  const [pathPart] = cleanedFilename.split("#");
  const parts = pathPart.split("/");
  // This is to include Guideline/SectionFile.dita
  // also Guideline/Subheader/SectionFile.dita
  if (parts.length < 2) {
    console.error('Invalid filename format. Expected: "Guideline/SectionFile.dita"', filename);
    return "#";
  }

  const guidelinePage = parts[0];
  const sectionFile = parts.at(-1);
  const normalizedFile = sectionFile.replace(".dita", "");

  //This Logic is temporary, later on if the publishing team provided correct href
  // then the logic to append trailing c_ can be removed
  const sectionId = normalizedFile.startsWith("c_") ? normalizedFile : `c_${normalizedFile}`;

  const guidelineInfo = mpstopicfile[guidelinePage];
  const topicfile = guidelineInfo?.topicfile || "";

  const url = `/viewTopic?etgAccess=true&guidelinePage=${guidelinePage}&topicfile=${topicfile}&guidelinename=auto&sectionId=${sectionId}#${sectionId}`;

  return url;
}

export function extractFilenameWithHash(path) {
  if (!path) return "";
  const [pathPart, hashPart] = path.split("#");
  const filename = pathPart.split("/").pop();
  return hashPart ? `${filename}#${hashPart}` : filename;
}
